"use client";

import { useEffect } from "react";
import { setupGlobalErrorHandling } from "src/utils/errorLogger";

export default function GlobalErrorHandler() {
  useEffect(() => {
    // Setup global error handling when the component mounts
    setupGlobalErrorHandling();
  }, []);

  // This component doesn't render anything
  return null;
}
